import './MapBottomLineControl.less';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import { Button } from 'antd';
import {
  cancelAddingGeometry,
  saveCurrentShape,
  selectAddingGeometryType,
  selectCurrentLine, selectEditingGeometryId,
} from '../../../store/slice/mapSlice';



function MapBottomLineControl() {
  const dispatch = useAppDispatch();

  const currentLine = useAppSelector(selectCurrentLine);
  const geometryType = useAppSelector(selectAddingGeometryType);
  const editingGeometry = useAppSelector(selectEditingGeometryId);

  const disabled = geometryType === 'linea' ? currentLine.length < 2 : currentLine.length < 3;
  return (
    <div className='at-map-bottom-line-control__container'>
      <div className='at-map-bottom-line-control__subcontainer'>
        <Button onClick={() => dispatch(cancelAddingGeometry())} type={'primary'} ghost={true}>
          Cancelar
        </Button>
        <Button disabled={disabled} onClick={() => dispatch(saveCurrentShape())} type={'primary'}>
          {(editingGeometry ? 'Guardar' : 'Agregar')} {geometryType === 'linea' ? ' Línea' : ' Polígono'}
        </Button>
      </div>
    </div>
  );
}

export default MapBottomLineControl;
